import { RootState } from '../../store/root';

const selectBySyncId = (state: RootState, syncId: string) =>
  state.tourStopOfflineStatus.status.filter(it => it.syncId === syncId);

export default {
  selectBySyncId,
};
